import { useEffect }  from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Home from "./pages/Home";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import SinglePost from "./pages/SinglePost";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ReactGA from 'react-ga4';

function App() {
  useEffect(() => {
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_TRACKING_ID);
        // Send pageview with a custom path
        ReactGA.send({ hitType: "pageview", page: "/", title: "Landing Page" });
    }, [])
  return (
    <I18nextProvider i18n={i18n}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route path="/register/" element={<Registration />} />
          <Route path="/login/" element={<Login />} />
          <Route
            path="/post/:postId/"
            element={
              <ProtectedRoute>
                <SinglePost />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/:profileId/"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/:profileId/edit/"
            element={
              <ProtectedRoute>
                <EditProfile />
              </ProtectedRoute>
            }
          />
        </Routes>
      </GoogleOAuthProvider>
    </I18nextProvider>
  );
}

export default App;
